module.exports = __webpack_public_path__ + "static/thpcbear2-26de56a94cd114e8d918a70f5b935f30.jpeg";